import { OrderApi } from '@linktivity/triplabo-taxi';

import config from '../config';

const order = new OrderApi(config);

export default order;
